import { api } from '../api';

export const souvenirService = {
  create: (data: any) => api.post('/souvenirs', data),
  update: (id: string, data: any) => api.put(`/souvenirs/${id}`, data),
  remove: (id: string) => api.delete(`/souvenirs/${id}`),
};